import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { notification } from 'antd'
import axiosMethod from 'utilities/apiCaller'
import { getAllCountries } from '../general/saga'
import registerAction from '../register/actions'

import actions from './actions'

const { gppPrivatePost, gppPrivateGet, gppPrivatePut } = axiosMethod

const userInfo = values => {
  const userId = values.value
  return gppPrivateGet(`screening-user-details/${userId}`).then(response => {
    return response.data
  })
}

export function* getUserInformation(values) {
  try {
    const response = yield call(userInfo, values)
    yield put({
      type: actions.SCREENING_GET_USER_INFROMATION_SUCCESS,
      value: response,
    })
    yield all([call(getAllCountries, '')])
  } catch (e) {
    yield put({
      type: actions.SCREENING_GET_USER_INFROMATION_FAILURE,
      value: e.response && e.response.data.message,
    })
  }
}

const updateUser = (data, userId) => {
  return gppPrivatePut(`screening-user-details/${userId}`, data).then(response => {
    return response.data.data
  })
}

export function* updateUserInformation(values) {
  const { payload } = values
  try {
    const userState = yield select(state => state.idvScreening)
    const response = yield call(updateUser, payload, userState.userId)
    yield put({
      type: actions.SCREENING_UPDATE_USER_INFROMATION_SUCCESS,
      value: response,
    })
  } catch (e) {
    yield put({
      type: actions.SCREENING_UPDATE_USER_INFROMATION_FAILURE,
    })
  }
}

const sendIDVInvite = values => {
  const { data, token } = values
  return gppPrivatePost(`send-idv-verification-link`, data, token).then(response => {
    return response
  })
}

export function* sendIDVInvitationLink(values) {
  const { payload } = values
  try {
    const response = yield call(sendIDVInvite, payload)
    yield put({
      type: actions.SCREENING_SEND_IDV_INVITATION_TO_VERIFY_SUCCESS,
      value: response,
    })
    yield put({
      type: registerAction.GET_ALL_STAKEHOLDERS,
      token: payload.token,
    })
    notification.success({
      description: 'Email sent successfully!',
    })
  } catch (e) {
    yield put({
      type: actions.SCREENING_SEND_IDV_INVITATION_TO_VERIFY_FAILURE,
    })
    notification.success({
      description: 'Something is wrong!',
    })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.SCREENING_GET_USER_INFROMATION, getUserInformation),
    takeEvery(actions.SCREENING_UPDATE_USER_INFROMATION, updateUserInformation),
    takeEvery(actions.SCREENING_SEND_IDV_INVITATION_TO_VERIFY, sendIDVInvitationLink),
  ])
}
